
import * as React from 'react'

class Terms_conditionsBanner extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div className="topic1 hero-bg shadow-small">
                <div className="uk-grid">        
                        <h3 className="uk-light uk-text uk-text-bold uk-text-white"> Terms Conditions... </h3>           
                </div>                 
            </div>
        )
    }
}

export default Terms_conditionsBanner; 